import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";
// i18next must initialize before any component reads strings.
// Side-effect import — the module wires itself into i18next on load.
import "./i18n";
// M3X.OBSERVABILITY — Sentry init must happen BEFORE React renders so
// any error during the initial mount is captured. Graceful no-op when
// VITE_SENTRY_DSN is unset (local dev / preview builds).
import { initSentry } from "./observability/sentry";

initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element '#root' not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
